import { CURRENCY_CODE, MODAL_SIZE } from '@constants'
import { ApplicationFeeDetailsModal, ApplicationFeeInfoModal, ApplicationFeeSuccessModal } from '@onboarding/components'
import { useMerchantAccounts, useMerchantQry } from 'mmfintech-backend-api'
import type { AccountBalanceResponse } from 'mmfintech-backend-api/types'
import { GlobalContext } from 'mmfintech-commons'
import { useContext } from 'react'

function usePayApplicationFee() {
  const { modalHide, modalShow } = useContext(GlobalContext)

  const { merchant } = useMerchantQry()
  const { activeAccounts } = useMerchantAccounts()

  function payApplicationFee() {
    modalHide()

    const euroAccount = activeAccounts.find(
      (account: AccountBalanceResponse) => account?.currencyCode === CURRENCY_CODE.EUR
    )

    if (euroAccount?.id && euroAccount?.availableBalance >= merchant?.accountSetupFee?.amount) {
      modalShow({
        content: (
          <ApplicationFeeInfoModal
            accountId={euroAccount.id}
            onSuccess={() => {
              modalShow({
                content: <ApplicationFeeSuccessModal />,
                options: {
                  size: MODAL_SIZE.AUTO,
                  transparent: true,
                  closeOnClickOutside: false,
                  closeOnEscape: false
                }
              })
            }}
          />
        ),
        options: {
          size: MODAL_SIZE.AUTO,
          transparent: true,
          closeOnClickOutside: false,
          closeOnEscape: false
        }
      })
    } else {
      modalShow({
        content: <ApplicationFeeDetailsModal />,
        options: {
          size: MODAL_SIZE.AUTO,
          transparent: true,
          closeOnClickOutside: true,
          closeOnEscape: true
        }
      })
    }
  }

  return {
    payApplicationFee
  }
}

export default usePayApplicationFee
